import { render, staticRenderFns } from "./addSolution.vue?vue&type=template&id=48f10dde&scoped=true&"
import script from "./addSolution.vue?vue&type=script&lang=js&"
export * from "./addSolution.vue?vue&type=script&lang=js&"
import style0 from "./addSolution.vue?vue&type=style&index=0&id=48f10dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f10dde",
  null
  
)

export default component.exports